{
  "more": "Więcej elementów"
}
